/** updateSearchParamsWithPagination takes an existing URLSearchParams and
 * updates it canonically using the given `page` object. */
export const updateSearchParamsWithPagination = (params, page = {}) => {
  if (!page) {
    return
  }
  if (page.limit) {
    params.set("limit", page.limit)
  } else {
    params.delete("limit")
  }
  if (page.offset != undefined) {
    params.set("offset", page.offset)
  } else {
    params.delete("limit")
  }

  return params.toString()
}
